import {ref} from 'vue'
import axios from 'axios'
import {log} from "@/composables/useLog"
import {BASE_URL} from "@/composables/url_config";
  const error = ref(null)
export const addNewClientService = async (token, form) => {
    log("welcome in addNewClientService cu parametrii token="+token )
    log("token")
    log(token)
    const API_URL =`${BASE_URL}/home/addNewClientServiceApi`;
    error.value = null
    try {
        error.value = null
        const headers= {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${token}`
        }
        const data = form;
        const result = await axios.post(API_URL, data, { headers });
        log("parameters data send:")
        log(data)
        error.value = null
        log ("result.data=");
        log (result.data);
        if(result.data.error==true){
            alert(result.data.message)
        }
        return result.data
    } catch (err){
        log("am intrat pe la catch (err) in addNewClientService")
        log(err.value)
        error.value=err.value
    }
}

const useAddNewClientService = () => {
        return { addNewClientService };
}
export default useAddNewClientService
